import * as API from './API'

export default {

    async saveCastingn() {
        let parameters = {
            method: 'PUT',
            path: '/api/users/castingn' 
        }
        const apiResponse = await API.request(parameters)
        return apiResponse
    },

    async checkUseridDuplication(uid) {
        let parameters = {
            method: 'GET',
            path: '/p/api/users/same-userid',
            params: {
                'userId': uid,
            }
        }
        const apiResponse = await API.request(parameters)
        return apiResponse
    },

    async sendAuthenticationSms(phonenumber) {
        let parameters = {
            method: 'GET',
            path: '/p/api/users/auth-hpnumber',
            params: {
                'hpNumber': phonenumber,
            }
        }
        const apiResponse = await API.request(parameters)
        return apiResponse
    },

    async signup(userinfo) {
        let parameters = {
            method: 'POST',
            path: '/p/api/users',
            params: {
                'userId': userinfo.userId,
                'password': userinfo.password,
                'userName': userinfo.userName,
                'hpNumber': userinfo.hpNumber,
                'authHpNumber': userinfo.authHpNumber
            }
        }
        const apiResponse = await API.request(parameters)
        return apiResponse
    },

    async login(uid, password) {
        let parameters = {
            method: 'POST',
            path: '/p/api/users/login',
            params: {
                'userId': uid,
                'password': password
            }
        }
        const apiResponse = await API.request(parameters)
        return apiResponse
    },

    logout() {
    },

    async getUserInfo(uuid) {
        let parameters = {
            method: 'GET',
            path: '/api/users/' + uuid,
            params: {}
        }
        const apiResponse = await API.request(parameters)
        return apiResponse
    },

    async checkPassword(uid, password) {
        //auth.setJwt(uid)
        let parameters = {
            method: 'POST',
            path: '/p/api/users/login',
            params: {
                'userId': uid,
                'password': password
            }
        }
        const apiResponse = await API.request(parameters)
        return apiResponse
    },

    async changePassword(uuid, password) {
        let parameters = {
            method: 'PUT',
            path: '/api/users/' + uuid,
            params: {
                'password': password
            }
        }
        const apiResponse = await API.request(parameters)
        return apiResponse
    },

    async findUserid(userName) {
        let parameters = {
            method: 'POST',
            path: '/p/api/users/userid',
            params: {
                'userName': userName
            }
        }
        const apiResponse = await API.request(parameters)
        return apiResponse
    },

    async findPassword(userId) {
        let parameters = {
            method: 'POST',
            path: '/p/api/users/password',
            params: {
                'userId': userId
            }
        }
        const apiResponse = await API.request(parameters)
        return apiResponse
    },

    async getInquiries(page, size) {
        let parameters = {
            method: 'GET',
            path: '/api/inquiries',
            params: {
                'page': page,
                'size': size
            }
        }
        const apiResponse = await API.request(parameters)
        return apiResponse
    },

    async getInquiry(uuid) {
        let parameters = {
            method: 'GET',
            path: '/api/inquiries/' + uuid,
            params: {}
        }
        const apiResponse = await API.request(parameters)
        return apiResponse
    },

    async submitInquiry(args) {
        let parameters = {
            method: 'POST',
            data: args.formData,
            path: '/api/inquiries',
            params: {}
        }
        const apiResponse = await API.formDataRequest(parameters)
        return apiResponse
    },

    async updateInquiry(args) {
        let parameters = {
            method: 'PUT',
            data: args.formData,
            path: '/api/inquiries/' + args.uuid,
            params: {}
        }
        const apiResponse = await API.formDataRequest(parameters)
        return apiResponse
    },

    async deleteInquiry(uuid) {
        let parameters = {
            method: 'DELETE',
            path: '/api/inquiries/' + uuid,
            params: {}
        }
        const apiResponse = await API.request(parameters)
        return apiResponse
    },

    async emailAuth(emailAuthCode) {
        let parameters = {
            method: 'GET',
            path: '/p/api/users/email-auth/' + emailAuthCode,
            params: {}
        }
        const apiResponse = await API.request(parameters)
        return apiResponse
    },

    async recertifyEmail(email) {
        let parameters = {
            method: 'GET',
            path: '/p/api/users/recertify-email?userId=' + email,
            params: {}
        }
        const apiResponse = await API.request(parameters)
        return apiResponse
    },


}



// WEBPACK FOOTER //
// ./src/service/userAPI.js